<div [class.hide]="!visible" class="fixed-bottom">
    <div class="menu-container">
        <div class="desktop-logo">
            <img
                class="logo"
                routerLink="/news"
                src="/assets/images/logo-desktop.svg"
            />
        </div>

        <ng-container *ngFor="let item of this.baseMenuItems">
            <div
                *ngIf="item.routerLink !== null"
                class="icon-container"
                routerDirection="root"
                routerLink="/{{ item.routerLink }}"
                routerLinkActive="active"
                [routerLinkActiveOptions]="item.routerLinkOptions"
            >
                <div class="item">
                    <svg-icon src="/assets/icon/{{ item.icon }}.svg"></svg-icon>
                    <span>{{ item.name | translate }}</span>
                </div>
            </div>

            <div *ngIf="item.routerLink === null" class="icon-container">
                <div class="item" (click)="showDocumentsMenu()">
                    <div class="icon-wrapper">
                        <svg-icon
                            src="/assets/icon/{{ item.icon }}.svg"
                        ></svg-icon>
                        <app-unread-badge
                            [count]="unreadReportsCount"
                            variant="dot"
                            top="2px"
                            right="-4px"
                            class="responsive-documents mobile-badge"
                        ></app-unread-badge>
                    </div>
                    <span class="documents-text">
                        {{ item.name | translate }}
                        <app-unread-badge
                            [count]="unreadReportsCount"
                            variant="dot"
                            [static]="true"
                            class="responsive-documents desktop-badge"
                        ></app-unread-badge>
                    </span>
                </div>
            </div>
        </ng-container>

        <div
            *ngFor="let item of this.menuItems"
            class="icon-container desktop"
            routerDirection="root"
            routerLink="/{{ item.routerLink }}"
            routerLinkActive="active"
            [routerLinkActiveOptions]="item.routerLinkOptions"
        >
            <div class="item">
                <svg-icon src="/assets/icon/{{ item.icon }}.svg"></svg-icon>
                <span>{{ item.name | translate }}</span>
            </div>
        </div>

        <div (click)="toggleMenu()" class="icon-container mobile">
            <div class="item">
                <svg-icon src="/assets/icon/baseline-menu-24px.svg"></svg-icon>
                <span>{{ "navigation.menu" | translate }}</span>
            </div>
        </div>
    </div>
</div>
